/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Reply_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter reply..." |
*
* @param {Event_Notes_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_reply_placeholder = /** @type {((inputs?: Event_Notes_Reply_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Reply_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez une reponse...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort eingeben...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la risposta...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите ответ...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introducir respuesta...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入回复内容……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信を入力してください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर दर्ज करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Digite a resposta...")
	return /** @type {LocalizedString} */ ("Enter reply...")
});